import {
  CLEAR_ERROR_MESSAGE,
  GET_MARKETERS_DETAILS,
  GET_TOKEN,
  GET_USER_DETAILS,
  GET_USER_DETAILS_FROM_LOCAL,
  SIGNOUT,
  TOKEN_ATTEMPT_ERROR,
} from '../actions/types';

const initialState = {
  token: {
    refresh: '',
    access: '',
  },
  email: '',
  id: '',
  role: '',
  first_name: '',
  last_name: '',
  errorMessage: '',
  marketerDetails: {
    id: '',
    team_id: '',
    phone: '',
    address: '',
    hiring_date: '',
    category: '',
  },
  loading: false,
};

const authReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case 'START_LOADING':
      return { ...state, loading: true };
    case 'STOP_LOADING':
      return { ...state, loading: false };

    case GET_TOKEN:
      const { refresh, access } = payload;

      return { ...state, token: { access, refresh }, errorMessage: '', loading: true };
    case GET_USER_DETAILS:
      const { id, first_name, last_name, email, role } = payload;
      localStorage.setItem('details', JSON.stringify(payload));
      return {
        ...state,
        id,
        first_name,
        last_name,
        email,
        role,
        errorMessage: '',
        loading: false,
      };

    case GET_MARKETERS_DETAILS:
      const { id: marketerId, team_id, phone, address, hiring_date, category } = payload;
      return {
        ...state,
        marketerDetails: {
          id: marketerId,
          team_id,
          phone,
          address,
          hiring_date,
          category,
        },
        loading: false,
      };

    case CLEAR_ERROR_MESSAGE:
      return { ...state, errorMessage: '', loading: false };

    case GET_USER_DETAILS_FROM_LOCAL:
      const {
        id: id1,
        first_name: first_name1,
        last_name: last_name1,
        email: email1,
        type: type1,
        atoken,
        rtoken,
      } = payload;
      return {
        ...state,
        id: id1,
        first_name: first_name1,
        last_name: last_name1,
        email: email1,
        type: type1,
        token: { access: atoken, refresh: rtoken },
        errorMessage: '',
      };

    case TOKEN_ATTEMPT_ERROR:
      return { ...state, errorMessage: payload, loading: false };
    case SIGNOUT:
      localStorage.clear();
      return { ...initialState, errorMessage: '', loading: false };
    case 'noting':
      return state;
    default:
      return state;
  }
};

export default authReducer;
